module.exports = __webpack_public_path__ + "img/brand-5.ffe283b1.png";